import {AccessorsMutatorsDecorator} from "../../helpers";
import {TranslatableModel} from "./translatable-model";

export class StaahRoomTypeModel extends TranslatableModel {
}

AccessorsMutatorsDecorator(
    'id', 'code', 'name'
)(StaahRoomTypeModel);


// WEBPACK FOOTER //
// ./src/pms-api/models/staah-room-type.model.js